import { EmopTableProHeaderFilterClass } from "./EmopTableProHeaderFilterClass";
import { EmopTableProHeaderSortClass } from "./EmopTableProHeaderSortClass";

export class EmopTableProHeaderClass {
  /**
   * 中文显示值
   */
  alias: string;
  /**
   * 排序对象
   */
  sort?: EmopTableProHeaderSortClass;
  /**
   * 筛选对象
   */
  filter?: EmopTableProHeaderFilterClass;
  /**
   * 表格头部标识符(用于获取参数等用途)
   */
  key: string;
  /**
   * 宽度
   */
  width?: string = null;

  constructor(constructorData: EmopTableProHeaderClass) {
    if (constructorData.sort) this.sort = new EmopTableProHeaderSortClass(constructorData.sort);
    delete constructorData.sort;
    if (constructorData.filter) this.filter = new EmopTableProHeaderFilterClass(constructorData.filter);
    delete constructorData.filter;
    // 将构造函数中的参数全部进行构造
    for (const key in constructorData) {
      if (constructorData[key] !== undefined) this[key] = constructorData[key];
    }
  }
}